import { http } from './http';
import { checkOrCreateChpoByDate, computeChpoDate } from './chpo';

export async function listChpoUsers(params = {}) {
  const { date, is_archived } = params || {};
  const dateISO = date || computeChpoDate();
  const ctx = await checkOrCreateChpoByDate(dateISO);
  let items = Array.isArray(ctx?.users) ? ctx.users : [];
  if (typeof is_archived === 'boolean') {
    items = items.filter(x => !!x.is_archived === is_archived);
  }
  return items.map((entry) => {
    const u = entry?.user || {};
    return {
      id: entry?.chpo_user_id ?? u?.id,
      chpo_user_id: entry?.chpo_user_id,
      user_id: u?.id, // Explicitly return user_id
      personal_number: u?.personal_number ?? '',
      is_archived: !!entry?.is_archived,
      rank: u?.rank || '',
      position: u?.position || '',
      fio: u?.full_name || '',
      full_name: u?.full_name || '',
      birth_date: u?.birth_date || '',
      call_date: u?.service_start_date || '',
      arrive_from: u?.arrival_info || '',
      depart_to: u?.departure_info || '',
      order_ref: u?.appointment_info || '',
      note: entry?.description || '',
    };
  });
}

export async function createChpoUser(payload) {
  const { data } = await http.post('chpo/chpo-user/', payload);
  return data;
}

export async function updateChpoUser(id, payload) {
  const { data } = await http.patch(`chpo/chpo-user/${id}/`, payload);
  return data;
}

export async function archiveUser(id) {
  return updateChpoUser(id, { is_archived: true });
}

export async function restoreUser(id) {
  return updateChpoUser(id, { is_archived: false });
}
